module.exports = __webpack_public_path__ + "static/media/item-clock.a7ad4c1d.png";